
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import { colors } from '@dbk-legacy/ui-constants';
import Text, { Large } from '@dbk/ui-text';
import { Percent } from '@dbk/ui-numbers'

import SimpleBarChart from '../../../../components/common/simpleChart';
import { Currency } from '../../../../components/common/number';
import { PALETTE } from '../../../../constants';
import { getCurrencyChartData } from '../../../../utils/get-chart-data-screen-reader';

var data = [];
var margins = { left: 50, right: 20, top: 10, bottom: 30 };

class CurrencyExposureChart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedInteractionValue: null,
    }
    this.handleInteractionChange = this.handleInteractionChange.bind(this);
    this.getScreenReaderData = this.getScreenReaderData.bind(this);
  }

  // For updating Interaction component(Tooltip) for bar chart
  handleInteractionChange(value) {
    this.setState({
      selectedInteractionValue: value,
    });
  }

  getScreenReaderData(data) {
    const { i18n: { messages } } = this.props;
    const msgObj = {
      graphDesc: messages['app.accessibility.chart.currencyClass'],
      currencyMsg: messages['app.report.transactionHistory.currency'],
      marketValueMsg: messages['app.portfolio.listassets.mktValue']
    }
    const screenReaderChartData = getCurrencyChartData(msgObj, data)
    return { ...screenReaderChartData };
  }

  render() {
    const currencyExposure = this.props.currencyChartData ? 
      JSON.parse(this.props.currencyChartData) : null;
    const currencyArray = currencyExposure? currencyExposure.currencyAllocation : []; // taking out the currency component array
    const { selectedInteractionValue } = this.state;
    const { i18n: { messages } } = this.props;
    if (!currencyArray || !currencyArray.length) {
      // If No or imporoper currency response received
      return (
        <div className="currencyChartNoData" tabIndex={0}>
          <Large>
            {messages['app.portfolio.dashboard.currencies']}
          </Large>
        </div>
      )
    } else {
      data = [];
      const destinationCurrency = this.props.referenceCurrency || currencyExposure.destinationCurrency;
      // Converting API response into chart component recognized format.
      currencyArray.forEach(ccy => {
        ccy.currencyPercentage = (ccy.currencyPercentage == null || ccy.currencyPercentage == undefined) ? 0 : ccy.currencyPercentage;
        ccy.currencyAmount = (ccy.currencyAmount == null || ccy.currencyAmount == undefined) ? 0 : ccy.currencyAmount;

        const combineValue = (
          <div className="white-all">
            <Currency
              renderProps={{ testID: 'market-value', currPercent: ccy.currencyPercentage, size: 'xsmall' }} 
              currency={destinationCurrency} 
              value={ccy.currencyAmount} />
            <div/>
            <Percent
              value={ccy.currencyPercentage}
            />
          </div>
        )
        data.push({ 
          titleText: ccy.currency.toUpperCase(), 
          value: ccy.currencyPercentage, 
          valueText: ccy.currencyAmount, 
          tooltipText: combineValue 
        });
      });

      // WMCE - 7700 , DATA ALREADY SORTED FROM BACKEND
      // data.sort(function (a, b) { 
      //   return parseFloat(b.value) - parseFloat(a.value);
      // });

      if (data.length == 1) {
        const blankObject = {
          titleText: " ",
          subTitleText: " ",
          valueText: 0,
          tooltipText: "",
          value: ""
        };
        data = [blankObject, data[0], blankObject];
      }

      return (
        <div className="currency-chart" tabIndex={0} {...this.getScreenReaderData(currencyArray)}>
          <SimpleBarChart
            bars={data}
            isTablet={true}
            selectedInteractionValue={selectedInteractionValue}
            onInteractionChange={this.handleInteractionChange}
            yaxislabeltext='(%)'
            xaxislabeltext='Currency'
            margins={margins}
            minHeightFactor={0.48}
            customBarColors={colors.color.currency}
            messages={messages}
            barColor={PALETTE.currencyChart}
           
          />
          {/* <div className="padding-left-10">
            <Text>{messages['portfolio.currencychart.disclaimer']}</Text>
          </div> */}
        </div>
      );
    }
  }
}

CurrencyExposureChart.propTypes = {
  currencyChartData: PropTypes.string,
  referenceCurrency: PropTypes.string
};

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
  },
}, )(CurrencyExposureChart);
